module.exports = __webpack_public_path__ + "static/media/03-banner-02-tienda-mobile@2x.5adab24b.jpg";